import styled from '@emotion/styled';
import { Section } from 'components/commons/Section';
import React from 'react';

const Image = styled.img`
  width: 100%;
`;

const CustomSection = styled(Section)`
  & a {
    text-decoration: underline;
  }
`;

export const Section2 = () => {
  return (
    <CustomSection>
      <Image
        alt="Map with mindsapp location"
        src="/assets/images/eukleiaMap.png"
      />
    </CustomSection>
  );
};
